<template>
  <label :class="['ui-checkbutton', { checked: modelValue }]">
    <input
      v-model="computedValue"
      type="checkbox"
    >
    <div
      v-if="$slots.icon"
      class="ui-checkbutton-icon"
    >
      <slot name="icon" />
    </div>
    <span>{{ label }}</span>
  </label>
</template>

<script>
export default {
  name: 'ui-checkbutton',

  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },

    label: {
      type: String,
      default: '',
    },
  },

  computed: {
    computedValue: {
      get() {
        return this.modelValue;
      },

      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
};
</script>

<style lang="scss">
.ui-checkbutton {
  position: relative;
  display: flex;
  align-items: center;
  padding: 7px 8px;
  background-color: #fff;
  border: 1px solid $gray_lu;
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  color: $black;
  user-select: none;
  cursor: pointer;
  transition: .2s border-color ease;

  &::after {
    content: '';
    position: absolute;
    top: -1px;
    bottom: -1px;
    right: -1px;
    left: -1px;
    opacity: 0;
    border: 2px solid $black;
    border-radius: 4px;
    transition: .2s opacity ease;
  }

  &:hover {
    border-color: $gray;
  }

  &.checked {
    &::after {
      opacity: 1;
    }

    .ui-checkbutton-icon {
      color: $black;
    }
  }

  input {
    @include stacking("behind");
    position: absolute;
    appearance: none;
  }

  &-icon {
    display: block;
    width: 24px;
    height: 24px;
    margin-right: 8px;
    color: $gray;
    transition: .2s color ease;
  }

  & > span {
    margin-top: 2px;
  }
}

@include breakpoint("desktop") {
  .ui-checkbutton {
    padding: 6px 12px;
    cursor: pointer;

    &-icon {
      margin-right: 8px;
    }
  }
}
</style>
